import React, { useState } from "react";
import Documents from "../../../../../components/common/forms/Documents";
import { upload_document_v2 } from "./CompanyShareSalesPurche";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import FormNewPayment from "../../../../../components/common/forms/FormNewPayment";
import ReusableNewCompany from "../common/ReusableNewCompany";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const NewCompanyShareSales = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState("");
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);

  const handleSub = (data) => {
    data.documents = docsOutput;
    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post(`services/company/`, data)
      .then((response) => {
        toast.success("Data Registered Successfully");

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.registration_id,
        //   created_by: response.data.registration_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof: uploadProof,
        //   company: response.data.company_id,
        //   transaction_type: "credit",
        // };

        // api
        //   .post("/transactions/", transactions)
        //   .then((response) => {
        //     toast.success("Data Registered 2 Successfully.");
        //   })
        //   .catch((error) => {
        //     toast.error("Error in Transaction");
        //   });
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong");
      });
  };

  let data_v2 = [];
  upload_document_v2.map((item, i) => {
    data_v2.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      <div className="mt-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>
      <ReusableNewCompany register={register} />
      {/*note closed */}
      {/* new company for 3 months close */}

      <div className=" border-primary-blue mt-3">
        <div className="flex items-center text-primary-blue my-4 font-semibold leading-10 text-center">
          <p className=" text-primary-blue font-Laila mr-2 text-lg underline">
            2. Upload Document
          </p>{" "}
          माथी ३ महिने विवरण पेश गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु{" "}
          <p className=" text-primary-red px-2 underline">Upload</p> गर्नुहोस ।
        </div>
      </div>
      {/* upload documents open */}
      <Documents
        documents_data={upload_document_v2}
        initialState={data_v2}
        setDocument={setDocsOutput}
      />

      {/* upload documents close */}
      <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline mx-2 ">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>

      <FormBranch register={register} />
      {/* <FormButtom /> */}
      {/* <FormPayment /> */}
      <FormButtom/>

      
      <NewFormPayment  handleSubmit={handleSubmit}
        handleClick={handleSub}
        setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default NewCompanyShareSales;
